module.exports = "/wwwroot/img/hero_search_block.png?ver=c5081b89";